export const APP_NAME = "Docs";
